import { SessionUser, UserRoles } from '@mangovoice/types'

/**
 * Extracts user information from a JWT token
 * @param token JWT token string
 * @returns SessionUser object or undefined if token is invalid/missing
 */
export const getUserFromToken = (token?: string): SessionUser | undefined => {
  if (!token) {
    return undefined
  }

  try {
    const tokenBody = token.split('.')[1]
    const tokenBodyDecoded = atob(tokenBody)
    const parsed = JSON.parse(tokenBodyDecoded)

    const {
      email,
      id: regularId,
      username: regularUsername,
      first_name: regularFirstName,
      last_name: regularLastName,
      ['custom:user_id']: customUserId,
      ['custom:first_name']: customFirstName,
      ['custom:last_name']: customLastName,
      ['cognito:username']: cognitoUsername,
    } = parsed

    // Cognito provides claims with either "custom:" or "cognito:" on them
    // This defaults to the cognito way, and falls back to the simpleJWT way
    // to ensure all profile data is proper.
    const first_name = customFirstName ?? regularFirstName
    const last_name = customLastName ?? regularLastName
    const username = cognitoUsername ?? regularUsername
    const id = customUserId ?? regularId

    return {
      id,
      username,
      first_name,
      last_name,
      email,
    }
  } catch (err) {
    console.error('Failed to parse JWT token:', err)
    return undefined
  }
}

export const isUserAdmin = (userRoles?: UserRoles): boolean => {
  if (!userRoles) return false

  const adminRoleNames = ['mango', 'super_user', 'admin']
  return (
    userRoles.is_superuser ||
    userRoles.roles?.some((role) =>
      adminRoleNames.some((adminRole) => role.name.includes(adminRole)),
    )
  )
}
